<div class="qa-tile-answers px-3 pt-3" *ngFor="let answer of qa?.answers; let i = index">
  <div class="pt-3" [ngClass]="{'border-top': i != 0}">
    <kl-qa-answer-tile [qa]="qa" [url]="url" [answer]="answer"></kl-qa-answer-tile>
  </div>
</div>
